module.exports = __webpack_public_path__ + "static/media/2 (12).9008943d.jpg";